import { angleUtil } from '../../lib/angleUtil-sidecar'
import { l } from '../../lib/imports'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { common } from '../../main/common-sidecar'
import type { IVoyageBody } from './voyageBodies'
import { voyageBodies } from './voyageBodies-sidecar'
import { voyageBodiesData } from './voyageBodiesData-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageJsonServerInterface } from './voyageJsonServerInterface-sidecar'

let _isDirty = false
let _saveDelay = 0
let _isLoaded = false
let _filename = '_hair_adjust'
let _dir = 'voyage-data'

function trySave() {
  if (_isDirty) {
    let dt = common.getUpdateDelta()
    _saveDelay += dt
    if (_saveDelay > 1) {
      doSave()
      _isDirty = false
    }
  }
}
function setDirty() {
  _isDirty = true
  _saveDelay = 0
}
export function getIsLoaded() {
  return _isLoaded
}

function doSave() {
  let hairs: any = []
  l.forEach(voyageBodiesData.hairs, (c) => {
    hairs.push(c.adj)
  })
  let d = { hairs }

  voyageJsonServerInterface.save(_filename, d, _dir)
}

export function doLoad() {
  _isLoaded = false
  voyageJsonServerInterface.loadAsync(_filename, _dir).then((d: any) => {
    let hairs = d.hairs
    l.forEach(voyageBodiesData.hairs, (c, cIdx) => {
      if (hairs[cIdx]) {
        c.adj = hairs[cIdx]
      }
    })
    // console.log('loaded data')
    // console.log(d)
    _isLoaded = true
  })
}

export interface IVoyageToolBodyAlign {
  body: IVoyageBody | null
  body2: IVoyageBody | null

  bodyIdx: number
  headIdx: number
  hairIdx: number
}

let _obj: IVoyageToolBodyAlign | null = null
export function get() {
  //assert.notNil(_obj, 'editor not created')
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

function create(): IVoyageToolBodyAlign {
  let obj: IVoyageToolBodyAlign = {
    body: null,
    body2: null,
    bodyIdx: 0,
    headIdx: 0,
    hairIdx: 0,
  }

  return obj
}

export function update() {
  let obj = get()
  if (voyageGameManager.get().mode !== 'body-align') {
    return
  }

  if (!obj.body || !obj.body2) {
    obj.body = voyageBodies.create()
    voyageBodies.moveToXY(obj.body, 500, 500, false)
    voyageBodies.scale(obj.body, 4)
    // voyageBodies.rotate(obj.body, angleUtil.turn * 0.05)

    obj.body2 = voyageBodies.create()
    voyageBodies.moveToXY(obj.body2, 800, 500, false)
    // voyageBodies.rotate(obj.body2, angleUtil.turn * 0.01)

    //voyageBodies.scale(obj.body2, 4)
  }

  // Spin testing
  // let ds = common.getUpdateDeltaScaled()
  // let speed = 0.25
  // voyageBodies.rotate(obj.body, obj.body.rotation + angleUtil.turn * ds * speed)
  // voyageBodies.rotate(
  //   obj.body2,
  //   obj.body2.rotation + angleUtil.turn * ds * speed,
  // )

  obj.bodyIdx = mathUtils.wrapIndex(obj.bodyIdx, voyageBodiesData.bodies)
  obj.headIdx = mathUtils.wrapIndex(obj.headIdx, voyageBodiesData.heads)
  obj.hairIdx = mathUtils.wrapIndex(obj.hairIdx, voyageBodiesData.hairs)

  voyageBodies.setBody(
    obj.body,
    mathUtils.getIndexWrapped(obj.bodyIdx, voyageBodiesData.bodies),
  )
  voyageBodies.setHead(
    obj.body,
    mathUtils.getIndexWrapped(obj.headIdx, voyageBodiesData.heads),
  )
  voyageBodies.setHair(
    obj.body,
    mathUtils.getIndexWrapped(obj.hairIdx, voyageBodiesData.hairs),
  )

  voyageBodies.setBody(
    obj.body2,
    mathUtils.getIndexWrapped(obj.bodyIdx, voyageBodiesData.bodies),
  )
  voyageBodies.setHead(
    obj.body2,
    mathUtils.getIndexWrapped(obj.headIdx, voyageBodiesData.heads),
  )
  voyageBodies.setHair(
    obj.body2,
    mathUtils.getIndexWrapped(obj.hairIdx, voyageBodiesData.hairs),
  )

  trySave()
}

export function adjust(ox: number, oy: number, sx: number, sy: number) {
  let obj = get()
  if (obj.body && obj.body2) {
    let adj = obj.body.hair.adj[obj.body.head.idx]
    adj.ox += ox
    adj.oy += oy
    adj.sx += sx * 0.01
    adj.sy += sy * 0.01

    voyageBodies.scale(obj.body, obj.body.scale)
    voyageBodies.scale(obj.body2, obj.body2.scale)

    setDirty()
  }
}
